// NOTE snake_case used to avoid aliasing a method named in backend code
import { SleepDiaryPayloads } from '@bighealth/types/src/services/SleepDiaryPayloads';
import { DiaryEntry } from '@bighealth/types/src/services/SleepDiaryPayloads/types';

/**
 *
 * @param {DiaryEntry} args
 */
const create_baseline_entities = (
  args: DiaryEntry
): SleepDiaryPayloads['create_baseline_entities']['request'] => {
  return {
    service_name: 'SleepDiary',
    service_version: '1',
    service_method: 'create_baseline_entities',
    args,
  };
};

export { create_baseline_entities };
